import Handlebars from "handlebars";

Handlebars.registerHelper("humanize", function (string) {
  return string.replace(/_/g, " ");
});
